import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative z-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute rounded-full bg-white top-0 left-0 w-full h-full z-0 transform scale-75" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "absolute -bottom-1 right-0 rounded-full bg-white w-1/4 h-1/4 transform scale-150 z-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon[_ctx.group]), {
      style: _normalizeStyle('color:' + _ctx.iconColor[_ctx.group]),
      class: "z-10 absolute"
    }, null, 8, ["style"])),
    (_ctx.gildClass !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.gildClass !== '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["absolute -bottom-1 right-0 rounded-full bg-gradient-to-br from-white w-1/4 h-1/4 transform scale-110 z-10", _ctx.gildClass])
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}